import { useCanvasTemplates } from '@/hooks/canvas/useCanvasTemplates';
import CompactPagination from '../commos/CompactPagination';
import CanvasThumbnailGrid from './CanvasThumbnailGrid';

const CanvasTemplatesTab = ({ search }: { search: string }) => {
  const { templates, isLoading, error, page, totalPages, setPage } = useCanvasTemplates(search);

  const renderList = () => {
    if (isLoading) return <p className="text-sm text-gray-500">Cargando templates...</p>;
    if (error) return <p className="text-sm text-red-600">{error}</p>;
    if (templates.length === 0) return <p className="text-sm text-gray-500">No se encontraron templates.</p>;
    return (
      <CanvasThumbnailGrid kind="template" items={templates.map((t) => ({ id: t.id, url: t.url, alt: t.name, dragUrl: t.fullUrl }))} />
    );
  };

  return (
    <div className="flex flex-col gap-4">
      {renderList()}
      <CompactPagination page={page} totalPages={error ? 0 : totalPages} onChangePage={setPage} />
    </div>
  );
};

export default CanvasTemplatesTab;
